Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GLink = void 0;

var core_1 = require("@emotion/core");

var gatsby_1 = require("gatsby");

var styled_system_1 = require("@wheelroom/styled-system");

var merge_ncss_1 = require("../lib/merge-ncss");

var element_1 = require("./element");

var g_link_reset_1 = require("./g-link-reset");

exports.GLink = function (props) {
  var label = {
    ncss: {
      label: 'g-link'
    }
  };
  var attrs = element_1.getElementAttrs(props);
  attrs.onClick = props.onClick;
  attrs.to = props.to;
  attrs.css = styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, merge_ncss_1.mergeNcss([label, g_link_reset_1.gLinkReset, props.wheel.elementNcss.gLink, props.wheel.style, props]));
  return core_1.jsx(gatsby_1.Link, Object.assign({
    activeClassName: "active"
  }, attrs), props.children);
};